import cx from 'classnames'
import React from 'react'

import styles from './index.module.scss'

export function Paragraph (props) {
  return (
    <p
      {...props.attributes}
      className={cx(props.attributes.className, styles.paragraph, {
        [styles.left]: props.element.align === 'left',
        [styles.center]: props.element.align === 'center',
        [styles.right]: props.element.align === 'right',
        [styles.justify]: props.element.align === 'justify'
      })}
      style={props.style}
    >
      {props.children}
    </p>
  )
}
